export interface Product {
  id: string;
  name: string;
  categorySlug: string;
  brand: string;
  price: number;
  unit: string;
  image: string;
  images?: string[];
}

export interface ProductListResponse {
  items: Product[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface ProductCountResponse {
  total: number;
}

export interface CategoryCountsResponse {
  total: number;
  categories: Record<string, number>;
}

export interface ProductListParams {
  page?: number;
  limit?: number;
  category?: string;
  q?: string;
  sort?: "name" | "name_desc" | "price" | "price_desc";
}

export type ProductCreate = Product;

export type ProductUpdate = Partial<Omit<Product, "id">>;

export const getProductImages = (product: Pick<Product, "image" | "images">): string[] => {
  if (product.images?.length) return product.images;
  if (product.image) return [product.image];
  return [];
};
